import React from "react";

const ContactSkeleton: React.FC = () => {
  return (
    <div className="section relative flex justify-center pb-0 max-sm:p-4 blue-bg-dots">
      <div className="container px-4 max-sm:px-0 grid grid-cols-3 gap-8 my-10">
        <div className="col-span-2 max-lg:col-span-3">
          <div className="h-8 w-56 skeleton"></div>

          <div className="my-8 grid grid-cols-2 gap-6">
            <div className="w-full max-sm:col-span-2">
              <div className="h-6 w-36 skeleton mb-2"></div>
              <div className="h-12 w-full skeleton"></div>
            </div>

            <div className="w-full max-sm:col-span-2">
              <div className="h-6 w-36 skeleton mb-2"></div>
              <div className="h-12 w-full skeleton"></div>
            </div>

            <div className="w-full max-sm:col-span-2">
              <div className="h-6 w-36 skeleton mb-2"></div>
              <div className="h-12 w-full skeleton"></div>
            </div>

            <div className="w-full max-sm:col-span-2">
              <div className="h-6 w-36 skeleton mb-2"></div>
              <div className="h-12 w-full skeleton"></div>
            </div>

            <div className="w-full max-sm:col-span-2 relative">
              <div className="h-6 w-36  skeleton mb-2"></div>
              <div className="h-12 w-full  skeleton"></div>
            </div>

            <div className="w-full col-span-2">
              <div className="h-6 w-36 skeleton mb-2"></div>
              <div className="h-36 w-full skeleton p-[1.6rem]"></div>
            </div>

            <div className="max-md:text-center">
              <div className="h-14 w-2/4 skeleton"></div>
            </div>
          </div>
        </div>

        <div className="max-lg:hidden mt-36 ml-24">
          <div className="h-[500px] w-[350px] skeleton"></div>
        </div>
      </div>
    </div>
  );
};
export default ContactSkeleton;
